module.exports = __webpack_public_path__ + "img/image 001.19ddfbf5.png";